import api from "./Api";

export default class DCeService {
  /**
   * Cria uma nova DCe (Declaração de Conteúdo Eletrônica)
   * POST /api/v1/dce
   */
  postCriarDCe(request, callback) {
    api
      .post(this.host() + "/api/v1/dce", request)
      .then((response) => {
        callback(null, response.data);
      })
      .catch((erro) => {
        callback(erro, null);
      });
  }

  /**
   * Consulta o status de uma DCe pelo requestCode
   * GET /api/v1/dce/:requestCode/status
   */
  getDCeStatus(requestCode, callback) {
    api
      .get(this.host() + `/api/v1/dce`, { params: { requestCode } })
      .then((response) => {
        callback(null, response.data);
      })
      .catch((erro) => {
        callback(erro, null);
      });
  }

  host() {
    return process.env.REACT_APP_HOST_API;
  }
}
